import { observer } from "mobx-react-lite"

import { ClFarmsSummaryCard } from "./cl-farms-summary-card"
import { ClassicPoolFarmingRewardsSummaryCard } from "./classic-pool-farming-rewards-summary-card"
import { DashboardGrandTotal } from "./dashboard-grand-total"
import { EarnedFeesSummaryCard } from "./earned-fees-summary-card"
import { ManualClPositionsSummaryCard } from "./manual-cl-positions-summary-card"
import { VotingRewardsSummaryCard } from "./voting-rewards-summary-card"

export const DashboardSummary = observer(() => {
  return (
    <div className="flex flex-col gap-4">
      <DashboardGrandTotal />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        <VotingRewardsSummaryCard />
        <ClassicPoolFarmingRewardsSummaryCard />
        <ClFarmsSummaryCard />
        <ManualClPositionsSummaryCard />
        <EarnedFeesSummaryCard />
      </div>
    </div>
  )
})
